import { render } from "./DeleteTableModalComponent.vue?vue&type=template&id=ba7003ce&scoped=true"
import script from "./DeleteTableModalComponent.vue?vue&type=script&lang=js"
export * from "./DeleteTableModalComponent.vue?vue&type=script&lang=js"

import "./DeleteTableModalComponent.vue?vue&type=style&index=0&id=ba7003ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7003ce"]])

export default __exports__